module.exports = __webpack_public_path__ + "e15feea60fa1e85b2d809ac5aaf6453f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/footBack.png
// module id = 121
// module chunks = 0